module.exports = __webpack_public_path__ + "assets/img/enginio_info_card_upptack_enginio.b59a198c.png";